import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { ActionAttachmentFilters } from '../../../commons/models/action-attachment.model';

@Component({
  selector: 'app-action-attachment-filters',
  templateUrl: './action-attachment-filters.component.html',
  styleUrls: ['./action-attachment-filters.component.scss']
})
export class ActionAttachmentFiltersComponent {


  @Output()
  onFilter: EventEmitter<ActionAttachmentFilters> = new EventEmitter();

  private _defaultFilters: ActionAttachmentFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getActionAttachmentFilters());
  }

  private _getActionAttachmentFilters(): ActionAttachmentFilters {
    let filters: ActionAttachmentFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): ActionAttachmentFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: ActionAttachmentFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
